<template>
  <div
    class="set-main-panel"
    fluid
  >
    <base-data-panel
      :set-metadata="setMetadata"
    />
    <timing-step-panel :set-metadata="setMetadata" />
    <hour-range-panel :set-metadata="setMetadata" />
  </div>
</template>

<style lang="sass" scoped>
.set-main-panel
  > *:not(:last-child)
    margin-bottom: 1em
</style>

<script>
import BaseDataPanel from './BaseDataPanel';
import TimingStepPanel from './TimingStepPanel';
import HourRangePanel from './HourRangePanel';

export default {
  components: {
    BaseDataPanel,
    TimingStepPanel,
    HourRangePanel,
  },
  props: {
    setMetadata: Object,
  },
  computed: {
    title() {
      return this.$t('supervision.regulation-sets-tab.set-title', {
        name: this.setMetadata.number,
      });
    },
  },
};
</script>
